export default __webpack_public_path__ + "static/media/gh_logo.bb8a5915.png";